module.exports = __webpack_public_path__ + "static/media/17_l_derevy_5.78_73.43.569e229c.png";